export default function Plot_Google() {
  return (
    <div>
      <h1>Plot_Google Component</h1>
    </div>
  );
}
